import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import FieldError from "Shared/Form/FieldError";
import styled from "styled-components";
import FormBody from "src/components/ContinueDeal/CreditApp/shared/FormBody";
import FormContainer from "src/components/ContinueDeal/CreditApp/shared/FormContainer";
import FormHeader from "src/components/ContinueDeal/CreditApp/shared/FormHeader";
import { ApplicationStore } from "src/store";
import { VehicleState } from "Types/state";
import Check from "../../../icons/Check";
import StepContent from "../../StepContent/StepContent";
import { BaseStepProps } from "../shared/BaseStepProps";

const TRANSLATION_KEY = "ContinueDeal.CreditApp.TermsAndConditions";

const TermsAndConditionsBody = styled(FormBody)`
    margin: 28px 0 0 40px;
    width: 85%;
`;

const BoldCopy = styled("span")`
    font-weight: 500;
`;

const NormalCopy = styled("span")`
    font-weight: 400;
`;

const InputContainer = styled("div")`
    cursor: pointer;
    display: flex;
    margin: 30px 0 0;
`;

const Checkbox = styled("div")`
    background-color: #e1e1e1;
    border: 1px solid #979797;
    height: 20px;
    margin: 0 0 0 40px;
    position: relative;
    width: 20px;
`;

const StyledFieldError = styled(FieldError)`
    margin: 15px 28px 0 70px;
`;

const Checkmark = styled(Check)`
    height: 14px;
    left: 3px;
    position: absolute;
    top: 3px;
    width: 14px;

    g {
        fill: #4a4a4a;
    }
`;

const CheckboxLabel = styled("span")`
    color: ${(props) => props.theme.palette.grey[100]};
    font-size: 15px;
    font-weight: 600;
    line-height: normal;
    margin: 2px 0 0 10px;
`;

const StepContentContainer = styled("div")`
    margin: 209px 22px 0;
`;

// tslint:disable-next-line:no-empty-interface
interface TermsAndConditionProps extends BaseStepProps {
    uuid: string;
    vehicle: VehicleState;
}
interface TermsAndConditionState {
    hasBeenValidated: boolean;
    isChecked: boolean;
    isValid: boolean;
}

class TermsAndConditions extends React.Component<TermsAndConditionProps & WithTranslation, TermsAndConditionState> {
    constructor(props: TermsAndConditionProps & WithTranslation) {
        super(props);
        this.state = {
            hasBeenValidated: false,
            isChecked: false,
            isValid: false,
        };
    }
    public render() {
        const { t } = this.props;
        const { hasBeenValidated, isValid } = this.state;

        return (
            <FormContainer className="TermsAndConditions__container">
                <FormHeader>{t(`${TRANSLATION_KEY}.title`)}</FormHeader>
                <TermsAndConditionsBody>
                    <BoldCopy>{t(`${TRANSLATION_KEY}.subtitle`)}</BoldCopy>
                    <br />
                    <br />
                    <NormalCopy>{t(`${TRANSLATION_KEY}.body`)}</NormalCopy>
                </TermsAndConditionsBody>
                <InputContainer className="TermsAndConditions__input--container" onClick={this.toggleCheck}>
                    <Checkbox>
                        {this.state.isChecked && <Checkmark className="TermsAndConditions__input--checkmark" />}
                    </Checkbox>
                    <CheckboxLabel>{t(`${TRANSLATION_KEY}.agreementCheckboxLabel`)}</CheckboxLabel>
                </InputContainer>
                {hasBeenValidated && !isValid && (
                    <StyledFieldError>{t(`${TRANSLATION_KEY}.agreementRequiredMessage`)}</StyledFieldError>
                )}
                <StepContentContainer>
                    <StepContent onBackClick={this.handleBackClick} onNextClick={this.handleNextClick} />
                </StepContentContainer>
            </FormContainer>
        );
    }

    private handleNextClick = () => {
        if (this.state.isChecked) {
            this.props.formSettings && "accept_privacy" in this.props.formSettings
                ? this.props.onNextClick({ tosAgreed: this.state.isChecked, acceptPrivacy: true })
                : this.props.onNextClick({ tosAgreed: this.state.isChecked });
        } else {
            this.setState({
                hasBeenValidated: true,
                isValid: false,
            });
        }
    };
    private handleBackClick = () => {
        this.props.onBackClick({ tosAgreed: this.state.isChecked });
    };

    private toggleCheck = () => {
        this.setState(({ isChecked }) => {
            return {
                hasBeenValidated: false,
                isChecked: !isChecked,
                isValid: !isChecked,
            };
        });
    };
}

export const TranslatedTermsAndConditions = withTranslation()(TermsAndConditions);

const mapStateToProps = ({ currentDeal, deal, vehicles }: ApplicationStore) => ({
    uuid: deal.uuid as string,
    vehicle: vehicles.entities[currentDeal.vin!],
});

export default connect(mapStateToProps)(TranslatedTermsAndConditions);
